import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';
import '@emotion/react';
import '../contexts/internal/StickyContext.js';
import { EditorContext } from '../contexts/internal/EditorContext.js';
import { setNode, removeNode } from '../utils/node.js';

var _excluded = ["tempCursor"];
function useEditorNode() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var displayMode = useContextSelector(EditorContext, function (context) {
    var _context$state$displa;
    return (_context$state$displa = context === null || context === void 0 ? void 0 : context.state.displayMode) !== null && _context$state$displa !== void 0 ? _context$state$displa : 'view';
  });
  var displayDate = useContextSelector(EditorContext, function (context) {
    var _context$state;
    return context === null || context === void 0 || (_context$state = context.state) === null || _context$state === void 0 ? void 0 : _context$state.displayDate;
  });
  var isSelected = useContextSelector(EditorContext, function (context) {
    return (context === null || context === void 0 ? void 0 : context.state) != null ? context.state.cursor.length === path.length && path.every(function (v, i) {
      return context.state.cursor[i] === v;
    }) : false;
  });
  var isChildSelected = useContextSelector(EditorContext, function (context) {
    return (context === null || context === void 0 ? void 0 : context.state) != null ? path.every(function (v, i) {
      return context.state.cursor[i] === v;
    }) : false;
  });
  var isHovered = useContextSelector(EditorContext, function (context) {
    if (!context) {
      return false;
    }
    if (!context.state.tempCursor) {
      return false;
    }
    return context.state.tempCursor.length === path.length && context.state.tempCursor.every(function (v, i) {
      return v === path[i];
    });
  });
  var setState = useContextSelector(EditorContext, function (context) {
    return context != null ? context.setState : function () {/* noop */};
  });
  var onSelect = useCallback(function () {
    return setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        cursor: path
      });
    });
  }, [setState, path]);
  var onHover = useCallback(function (path) {
    setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        tempCursor: path
      });
    });
  }, []);
  var onUnhover = useCallback(function () {
    setState(function (_ref) {
      _ref.tempCursor;
        var state = _objectWithoutProperties(_ref, _excluded);
      return state;
    });
  }, []);
  var onChange = useCallback(function (node) {
    return setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        cursor: path,
        document: setNode(state.document, path, node)
      });
    });
  }, [setState, path]);
  var onRemove = useCallback(function () {
    return setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        document: removeNode(state.document, path)
      });
    });
  }, [setState, path]);
  return {
    isSelected: isSelected,
    isChildSelected: isChildSelected,
    isHovered: isHovered,
    displayMode: displayMode,
    displayDate: displayDate,
    onSelect: onSelect,
    onHover: onHover,
    onUnhover: onUnhover,
    onChange: onChange,
    onRemove: onRemove
  };
}

export { useEditorNode };
//# sourceMappingURL=useEditorNode.js.map
